var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLegifrance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 218.77 41.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e74b5;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.4,28.3v4.6H0V2.4h5.1v25.9h13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m43.4,23.2h-17.5c.6,3.5,3.7,5.9,7.2,5.8,2.5,0,4.8-1,6.5-2.7l2.7,2.8c-2.5,2.6-6,4-9.6,3.9-7.1.1-11.8-4.7-11.8-11.6s4.9-11.8,11.7-11.8c8.1-.1,11.4,5.3,10.8,13.6Zm-4.3-3.6c-.2-3.7-2.7-6-6.4-6s-6.2,2.3-6.8,6h13.2Zm-9.7-13.2l4.6-6.4,5.1,2.2-5.3,4.2h-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.6,30.6c0,6.7-4.8,10.8-12,10.8-3.4,0-6.8-1.1-9.6-3l2.1-3.6c2.1,1.6,4.6,2.5,7.3,2.5,4.4,0,7.3-2.6,7.3-6.6v-2.9c-1.7,2.6-4.6,4.1-7.7,3.9-6.3,0-10.5-4.5-10.5-11.2s4.2-11,10.3-11c3.1-.2,6.1,1.3,7.8,3.9v-3.7h5v20.9Zm-5-9.9c0-4.2-2.8-7.1-6.7-7.1s-6.7,2.9-6.8,7.1c0,4.2,2.8,7.1,6.8,7.1s6.7-2.9,6.7-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.9,3.1c0,1.6-1.3,2.9-2.9,2.9s-2.9-1.3-2.9-2.9,1.2-3,2.9-3c1.6,0,3,1.2,3,2.9q-.1,0-.1.1Zm-5.4,29.8V9.7h5v23.2h-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.9,7.9v2.8h6.1v3.7h-6.1v18.5h-5V14.4h-3v-3.7h3v-2.3c0-5.4,4-8,8-8,1.9,0,3.7.5,5.2,1.6l-1.9,3.8c-.9-.7-2-1-3.2-1.1-1.6-.2-3,1-3.2,2.6.1.2.1.4.1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.9,14.4c1.5-3.1,4.6-5,8-4.8v4.8c-4.7-.3-7.6,2.5-8,6.4v12.1h-5V9.7h5v4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m134,30.1c-1.6,2.1-4.3,3-7.7,3-5,0-8.2-3.1-8.2-7.2s3.2-6.9,8.8-7h7v-.7c0-2.9-1.9-4.7-5.6-4.7-2.5.1-4.9.9-6.9,2.3l-2.1-3.5c2.9-2,6.4-3,10-2.9,6,0,9.3,3,9.4,8.2v15.2h-4.6l-.1-2.7Zm0-5.3v-2.2h-6.3c-3.3,0-4.8.9-4.8,3.1s1.7,3.5,4.5,3.5c3.6,0,6.3-1.9,6.6-4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.9,18.5v14.4h-5v-13c0-3.5-2.1-5.6-5.6-5.6-3.8,0-6.2,2.7-6.6,6.3v12.3h-5V9.7h5v4.4c1.6-3.2,4.6-4.6,8.5-4.6,5.4,0,8.7,3.5,8.7,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m193.7,13.3l-2.8,3.2c-1.7-1.8-4.2-2.7-6.6-2.6-4,0-6.9,3-6.9,7.4s2.9,7.4,6.9,7.4c2.6.1,5.1-.9,6.9-2.8l2.8,2.8c-2.1,2.8-5.5,4.3-9.9,4.3-6.9,0-11.7-4.8-11.7-11.7s4.8-11.8,11.7-11.8c4.2,0,7.4,1.4,9.6,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m218.7,23.2h-17.5c.6,3.4,3.7,5.9,7.2,5.8,2.5,0,4.8-1,6.5-2.7l2.7,2.8c-2.5,2.6-6,4-9.6,3.9-7.1,0-11.9-4.8-11.9-11.7s4.9-11.8,11.7-11.8c8.2,0,11.5,5.4,10.9,13.7Zm-4.4-3.6c-.2-3.7-2.7-6-6.4-6s-6.2,2.3-6.8,6h13.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLegifrance);
export default __webpack_public_path__ + "static/media/logo-legifrance.cefd1646f4e0ca27b13b9970f72bd7b4.svg";
export { ForwardRef as ReactComponent };